module.exports = function(video) {
	"use strict";
  video
  .controller('allVideosController', allVideosController);
	allVideosController.$inject = ["addToOther","$http","API_URL","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","reqursiveService","deleteDataService","comunicateBetweenViews","offlineError"];
	
  function allVideosController(addToOther, $http,API_URL,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,reqursiveService, deleteDataService, comunicateBetweenViews,offlineError) {
    var vmav = this;
    vmav.config = config;
    $rootScope.emptyTable = false;
    vmav.editMediaModalShow = false;
    vmav.showGrid = false;
    vmav.selectedImage = -1;
    vmav.editVideoShow = false;
    vmav.selectedMediatoEdit = 0;
    vmav.commentPostId = null;
    vmav.commentsType = 'video';
    var state = 'video';
    var page = 1;
    var author;
    var date_start;
    var date_end;
    var sortby ='date';
    var s;
    var category;
    var $data;
    var tag;
    vmav.status = 'publish';
    var status = vmav.status;
    vmav.attachmentId = $stateParams.id;
    vmav.selectedCategory = {value: 'all'};
    vmav.selectedAuthorFilter = {value: 'all'};
    if($stateParams.id) {
      vmav.editVideoShow = true;
    } else {
      vmav.editVideoShow = false;
    }
    if(comunicateBetweenViews.getCategory()) {
      category = comunicateBetweenViews.getCategory();
      vmav.selectedCategory= {value: category};
      comunicateBetweenViews.setCategory(null);
    }
    if(comunicateBetweenViews.getTag()) {
      tag = comunicateBetweenViews.getTag();
      comunicateBetweenViews.setTag(null);
    }
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vmav.searchComment = function(count,postId) {
      vmav.commentPostId =  postId;           
      vmav.serchCommentsModalShow = true;
      $rootScope.modalShow = true;
    } 
    vmav.closeSearchComment = function() {
      vmav.serchCommentsModalShow = false;
      $rootScope.modalShow = false;
      vmav.commentPostId = null;
    }
    vmav.addToOther = addToOther;
    vmav.editVideo = function(attachmentId) {
      jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      vmav.attachmentId = attachmentId;
      vmav.editVideoShow = true;
      $state.transitionTo('app.allvideos', {id: vmav.attachmentId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmav.getGrid = function() {
      var grid_wrapp = angular.element(document.getElementsByClassName("grid-wrapper"));
      var table = angular.element(document.getElementsByClassName("table"));
      table.after(grid_wrapp);    
    }
    vmav.updateStatusPost = function(video_id,videoStatus) {
      var updateFunction = function() {
        $rootScope.hasLoaded = false;
        var url = API_URL + state + '/status';
        var videoData = {
            'status': videoStatus,
            'id':video_id
        } 
        $http.put(url , videoData)
        .success(function (data, stat, headers) {
            $rootScope.hasLoaded = true;
            alertService('success','Success ', data.message, 2000);
            vmav.tableParams.reload();  
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    updateFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                  // report progress
          });
          }else if(status ==502) {
              serverError()  
          }else { 
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      updateFunction();    
    }
    var deleteFunction = function(videoId) {
      deleteDataService.remove({
        param1:state, 
        param2: videoId,
        })
        .$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
          vmav.tableParams.reload();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                deleteFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(error.status ==502) {
          serverError();
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;
      });
    }
    var updateOrder = function(url,order) {
      var updateDataPost = {
        "order": parseInt(order)
      }
      var updateFunction = function() {
        $http.put(url , updateDataPost)
        .success(function (data, stat, headers) {
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  updateFunction();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError()  
          } else { 
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      updateFunction();
    }
    vmav.changeOrder = function() {
      vmav.changeOrderFlag = true;
    }
    vmav.outOrderFocus = function(postId,order) {
      if(vmav.changeOrderFlag) {
        $rootScope.hasLoaded = false;
        vmav.changeOrderFlag = false;
        updateOrder(API_URL+ "video/order/"+postId,order);
      }
    }
    vmav.updateOrder = function(postId,order) {
      updateOrder(API_URL+ "posts/"+postId,order);
    }
    vmav.deletePosts = function(post_id) {
      deleteFunction(post_id);  
    }
    vmav.categoryTreeFunction= function() {
      vmav.categoriesTreeInput = reqursiveService.getReqursiveArray(vmav.categories);
      vmav.categoriesTreeSelect = angular.copy(vmav.categoriesTreeInput);
      for(var i=0; i< vmav.categoriesTreeSelect.length; i++) {
        var n = (vmav.categoriesTreeSelect[i].ancestors.length)*2;
        var empty = "\u00A0";
        for(var j=0;j<n;j++) {
          vmav.categoriesTreeSelect[i].name = empty+vmav.categoriesTreeSelect[i].name;
        }
      }
    }
    var getCategoriesFunction = function() {
      getDataService.get({param1:'video-categories', tree:1}).$promise.then(function(data){      
        vmav.loadCategory= true;
        vmav.categories = data.categories;
        vmav.categoryTreeFunction();
        
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getCategoriesFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }
      });
    }
    getCategoriesFunction();
    var getAuthorsFunction = function() {
      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
        vmav.authorList = data.users;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getAuthorsFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getAuthorsFunction();
    var reloadTableFunction = function() {
      if(vmav.tableParams.page() ==1) {
        vmav.tableParams.reload();
      } else {
        vmav.tableParams.page(1);
      }
    } 
    vmav.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        $timeout(function() {
          vmav.search();
        },0)            
      }
    }
    vmav.switchCategories = function(item) {
      category = item;
      if (item =='all') {
          category = null;
      }
    }
    vmav.switchAuthorFilter = function(item) {
      author = item;
      if (item=='all') {
        author = null;
      }
    }
    vmav.changeDate = function(value) {
      vmav.dateRangevalue= value;
      if(vmav.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
        date_start = null;
        date_end = null;
      }
    }
    vmav.mediaFilters = function() {
      reloadTableFunction();
    }
    vmav.resetAllFilters = function() {
      vmav.status = 'publish';
      status = vmav.status;
      vmav.searchData = null;
      s =null;
      category=null;
      author = null;
      date_start = null;
      date_end = null;
      tag = null;
      vmav.selectedCategory = {value: 'all'};
      vmav.selectedAuthorFilter = {value: 'all'};
      $scope.$broadcast('clear-daterange',true);
      reloadTableFunction();
    }
    vmav.authorPosts = function(value) {
      author = value;
      reloadTableFunction();
    }
    vmav.categoryPosts = function(value) {
      category = value;
      reloadTableFunction();
    }
    vmav.tagPosts = function(value) {
      tag = value;
      reloadTableFunction();
    }
    vmav.changeStatus =function(event,activeStatus) {
      vmav.status = activeStatus; 
      if(activeStatus == 'all') {
        status = null;
      } else {
        status = activeStatus;
      }
      if(activeStatus == 'trash') {
        vmav.statusTrash = true;
      } else {
        vmav.statusTrash = false;
      }
      reloadTableFunction();
    }
    vmav.search =function(value) {
      if(value) {
        s = value.toLowerCase();
      } else {
        s = null;
      }
      reloadTableFunction();
    }
    vmav.tableReloadFunction = function(page) { 
      vmav.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            page: params.page(),
            limit: params.count(),
            author: author,
            s:s,
            status:status,
            category:category,
            tag:tag,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end
            }).$promise.then(function(data){
              $rootScope.hasLoaded = true;
              vmav.dataGet = data.videos;
              vmav.data_grid =data.videos;
              $data =data.videos;
              for(var i = 0; i < $data.length;i++) {
                if($data[i].image && vmav.config.baseVideoHref) {
                  var displayRes = ($data[i].orientation=='portrait')?'-360x640.jpg' : '-254x191.jpg';
                  $data[i].imageThumb = vmav.config.baseVideoHref + $data[i].image.replace('.jpg',displayRes)
                }
                if($data[i].duration){
                  var formatedTime;
                  if($data[i].duration>=3600) {
                    formatedTime = 'H:mm:ss'
                  } else{
                    formatedTime = 'm:ss'
                  }
                  $data[i].formated_duration = moment().startOf('day').second($data[i].duration).format(formatedTime);
                }
              }
              $rootScope.emptyTable = false;
              params.total(data.count);
              params.numPages(data.max_pages);
              jQuery('.goTo input').val("");
              if(vmav.showGrid){
                $timeout(function() {
                  vmav.getGrid();
                },0)
              }
              return $data;
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError('refresh')
                $rootScope.hasLoaded = true;
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {
                      vmav.tableReloadFunction(params.page());
                    }
                    // do something
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                  });
              } else if(error.status ==404) {
                $rootScope.emptyTable = true;
              } else if(error.status ==502) {
                serverError();
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;
            });
          }    
      });
    }
    vmav.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video/js/allVideosController.js
// module id = 659
// module chunks = 0